import { render, staticRenderFns } from "./RemoteEntitiesHome.vue?vue&type=template&id=8a95e462&"
import script from "./RemoteEntitiesHome.vue?vue&type=script&lang=ts&"
export * from "./RemoteEntitiesHome.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteEntitiesHome.vue?vue&type=style&index=0&id=8a95e462&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports